"use client";

import React from "react";

import { ClusterSelectionListSkeleton } from "./cluster-selection/cluster-selection-list-skeleton";
import { ClusterSelectionPanelLayout } from "./cluster-selection/cluster-selection-panel-layout";
import { ClusterSelectionSummarySkeleton } from "./cluster-selection/cluster-selection-summary-skeleton";
import { PROJECT_CLUSTER_PANEL_DICTIONARY } from "./project-cluster-summary.constants";

export const ProjectClusterPanelSkeleton: React.FC = () => {
  return (
    <ClusterSelectionPanelLayout>
      <ClusterSelectionSummarySkeleton metricCount={2} />
      <ClusterSelectionListSkeleton
        sectionTitle={PROJECT_CLUSTER_PANEL_DICTIONARY.newHousingProjects}
      />
    </ClusterSelectionPanelLayout>
  );
};
